import { useQuery } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import GetInitialDataQuery from '@/graphql/contracts/getInitialData.query.gql';
import { GetInitialData, GetInitialDataVariables } from '@/graphql/contracts/_generated_/getInitialData.query';

export default function useGetInitialData() {
  const { data, loading, called, error } = useQuery<GetInitialData, GetInitialDataVariables>(
    GetInitialDataQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'cache-first',
      nextFetchPolicy: 'cache-only',
      variables: {
        includeNonShowableBillingIntervals: true,
      },
      onError: (err) => {
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        });
      },
    });

  return {
    initialData: data,
    isLoading: loading,
    isApiCalled: called,
    error,
  };
}
